import SupportUsSection from "./Sections/SupportUsSection"

const Support = () => (
    <>
    <SupportUsSection/>
    </>
)

export default Support